import React from 'react';
import { AskRequest } from '@hone-automation/common/lib/AskRequests';
import { MobileSlideUpPanel } from 'presentation/components/Mobile/MobileSlideUpPanel/MobileSlideUpPanel';
import SummarizePanel from 'presentation/components/Queue/panels/SummarizePanel/SummarizePanel';
import { useQueueRequestsQuery } from 'hooks/useQueueRequestsQuery';
import './RequestSummarizePanel.scss';

interface RequestSummarizePanelProps {
  requestId: string;
  isOpen: boolean;
  onClose: () => void;
  titleIcon?: React.ReactNode;
}

/**
 * Mobile-specific wrapper for the SummarizePanel component
 * This component fetches the request data and passes it to the SummarizePanel
 */
const RequestSummarizePanel: React.FC<RequestSummarizePanelProps> = ({ requestId, isOpen, onClose, titleIcon }) => {
  // Fetch the request data
  const { data: requests, isLoading, error } = useQueueRequestsQuery();

  // Find the request with the matching ID
  const request = requests?.find(req => req.id === requestId);

  return (
    <MobileSlideUpPanel
      isOpen={isOpen}
      onClose={onClose}
      title="Request Summary"
      fullSizeOnOpen={true}
      titleIcon={titleIcon}
      showBetaBadge={true}
    >
      <div className="mobile-summarize-panel-wrapper">
        {isLoading ? (
          <div className="loading-indicator">Loading request data...</div>
        ) : error ? (
          <div className="error-message">Error loading request data</div>
        ) : !request ? (
          <div className="error-message">Request not found</div>
        ) : (
          <SummarizePanel request={request} className="mobile-summarize-panel" />
        )}
      </div>
    </MobileSlideUpPanel>
  );
};

export default RequestSummarizePanel;
